import Alpine from 'alpinejs';

Alpine.data('cursorFollower', (text) => ({
  cursorVisible: false,
  cursorText: text,
  
  init() {
    this.setupCursor();
  },
  
  setupCursor() {
    // Create cursor element
    this.cursorElement = document.createElement('div');
    this.cursorElement.className = 'custom-cursor';
    this.cursorElement.textContent = this.cursorText;
    this.cursorElement.style.cssText = `
      position: fixed;
      top: -100px;
      left: -100px;
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 0.5rem 0.75rem;
      border-radius: 4px;
      font-size: 0.8rem;
      font-weight: 600;
      pointer-events: none;
      z-index: 1000;
      opacity: 0;
      transition: opacity 0.2s ease;
      transform: translate(-50%, -50%);
    `;
    document.body.appendChild(this.cursorElement);
    
    // Add event listeners
    this.$el.addEventListener('mouseenter', () => {
      this.cursorVisible = true;
      this.cursorElement.style.opacity = '1';
      document.body.style.cursor = 'none';
    });
    
    this.$el.addEventListener('mouseleave', () => {
      this.cursorVisible = false;
      this.cursorElement.style.opacity = '0';
      document.body.style.cursor = 'auto';
    });
    
    this.$el.addEventListener('mousemove', (e) => {
      if (this.cursorVisible) {
        this.cursorElement.style.left = e.clientX + 'px';
        this.cursorElement.style.top = e.clientY + 'px';
      }
    });
  },
  
  destroy() {
    if (this.cursorElement) {
      document.body.removeChild(this.cursorElement);
      document.body.style.cursor = 'auto';
    }
  }
}));